import * as styles from './modal.module.scss';

const redirectCustomerServicePage = () => {
  window.location.href = process.env.REACT_APP_CUSTOMER_SERVICE_URL || '';
};

type ErrorModalProps = {
  isOpen: boolean;
  onClose: () => void;
  isTransactionDeclined: boolean;
  transactionDeclinedMsg: string;
};

const ErrorModal = ({
  isOpen = false,
  onClose = () => {},
  isTransactionDeclined,
  transactionDeclinedMsg,
}: ErrorModalProps) =>
  isOpen ? (
    <div className={styles.container}>
      <div className={`${styles.modal} ${isTransactionDeclined ? styles.isTransactionError : ''}`}>
        <div className={styles.header}>
          <div className={styles.title}>
            {isTransactionDeclined ? 'Transaction Declined' : 'Transaction Error'}
          </div>
          <div
            className={styles.close}
            onClick={onClose}
            onKeyPress={onClose}
            tabIndex={0}
            role="button"
            aria-label="close"
          >
            <i className="fas fa-times-circle" />
          </div>
        </div>
        <div className={styles.subtitle}>
          <i className="fal fa-frown-open" />
        </div>
        <div className={styles.content}>
          {isTransactionDeclined
            ? transactionDeclinedMsg ||
              'Please update your payment information\n' + 'to continue with your purchase.'
            : 'There was an problem\nprocessing your transaction.\nadditional help with this issue.'}
        </div>
        <div className={styles.buttons}>
          {!isTransactionDeclined && (
            <button
              className={styles.btnPrimaryOutline}
              type="button"
              onClick={redirectCustomerServicePage}
            >
              CUSTOMER SERVICE
            </button>
          )}
          <button className={styles.btnPrimary} type="button" onClick={onClose}>
            CLOSE
          </button>
        </div>
      </div>
    </div>
  ) : null;

export default ErrorModal;
